$("body").on("click", ".mini-filter", function(){
  $("body").toggleClass("open_filter");
});



$(window).on('beforeunload', function () {
  function delete_cookie( name ) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  console.log('test');
  
  var isAnAdult = readCookie('isAnAdult');
  if (isAnAdult) {
  	delete_cookie("isAnAdult");
      var date = new Date();
      date.setTime(date.getTime()+(60*60*1000));
      var expires = "; expires="+date.toGMTString();
      document.cookie = 'isAnAdult=true;'+expires+"; path=/";
  };
});

// $(window).unload(function () {
//    //alert('test');
//     //$.cookie("isAnAdult", null);
//   $.removeCookie("isAnAdult");
// });